import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
document.title = "MegaPack Arteterapia | RecursoPDF";
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-175" data-mp="218we2zodm29x" />);
}